import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { funloadHistry } from "../redux/DashbordSlice"
import { makeAuthenticatedRequest } from "../utils/api";
import { 
  faBars,
  faSearch,
  faBell,
  faUserCircle,
  faMagnifyingGlass
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AxiosError } from "../components/sessionexpiry";

const FundLoad = ({isSidebarCollapsed,isMobile}) => {

  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const limit = 15;
  const offset = (currentPage - 1) * limit;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const merchantData = useSelector((state) => state.Dashboard.fundloadslist);

  const users = JSON.parse(sessionStorage.getItem("users"));
  const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";

  const fetchData = async () => {

    const dateOnly = new Date().toISOString().slice(0, 10);

    try {
      const requestData = JSON.stringify({
        Dname: "flipopay_payouts",
        Tname: "fund_history",
        Cname: [
          "mid",
          "amount",
          "reference",
          "open_balance",
          "close_balance",
          "status",
          "created_at"
        ],
        Where: [
          { 
            column: "mid",
            operator: "=",
            value: user_id
          },
        ],
        Order: { id: "desc" },
        Search: searchTerm,
        Limit: `${limit}`,
        Offset: `${offset}`,
      });

      const encrypted = encrypt(requestData);
      const data = await makeAuthenticatedRequest(
        "POST",
        "/fetch",
        { encrypted },
        navigate
      );
      
      const decryptdata = decrypt(data);
      const fixedString = decryptdata.replace(/\\"/g, '"');
      const jsonArray = JSON.parse(fixedString);

      dispatch(funloadHistry(jsonArray)); // Pass the entire response  

    } catch (err) {
      setError(err.message);
      AxiosError(navigate, err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchTerm, currentPage]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when new search happens
  };

  const goToNextPage = () => setCurrentPage(prev => prev + 1);
  const goToPrevPage = () => setCurrentPage(prev => (prev > 1 ? prev - 1 : 1));

  const totalPages = Math.ceil(totalCount / limit); // Calculate total pages

  const fundloads = merchantData && merchantData.length > 0 ? merchantData : [];

  return (
    <div className={`bg-[#F4F5FA] min-h-screen`}>
      {/* Header & Sidebar */}
      {/* <Header
        toggleSidebar={toggleSidebar}
        isSidebarCollapsed={isSidebarCollapsed}
      />
      <Sidebar
        isSidebarCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
      /> */}


      <main className="main-content">
        <div
          className={`mx-auto p-4 md:p-4 transition-all duration-300 ${
            isSidebarCollapsed && !isMobile ? "lg:ml-20" : 
            !isSidebarCollapsed && !isMobile ? "lg:ml-[270px]" : 
          "ml-0"
          }`}
        >
          {/* Main Content */}
          <div class="mb-6 flex flex-wrap items-center justify-between ml-4">
            <h2 class="text-xl font-semibold text-gray-800">
              Fund History
            </h2>

            <nav>
              <ol class="flex items-center gap-1.5 mr-7">
                <li>
                  <a
                    class="inline-flex items-center gap-1.5 text-sm text-gray-500"
                    href="index.html"
                  >
                    Home /
                  </a>
                </li>
                <li class="text-sm text-gray-800">
                  Fund History
                </li>
              </ol>
            </nav>
          </div>

          {/* Main content goes here */}

          {/* Search Bar & Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center bg-white p-4 mt-8 rounded-xl shadow-md">
        {/* Search Bar */}
        <div className="flex items-center bg-gray-100 border border-gray-300 rounded-full px-4 py-2 w-full sm:w-80 mb-4 sm:mb-0">
          <FontAwesomeIcon icon={faMagnifyingGlass} className="text-gray-500 mr-2" />
          <input
            type="text"
            placeholder="Search Keyword"
            className="bg-transparent outline-none w-full text-gray-800 placeholder-gray-500"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>

        {/* Pagination */}
        <div className="flex items-center space-x-3">
          <button
            onClick={goToPrevPage}
            className="px-3 py-1 rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 transition duration-150"
            disabled={currentPage === 1}
          >
            &lt;
          </button>

          <span className="text-sm font-medium text-gray-700">
            Page <span className="font-bold">{currentPage}</span> of{" "}
            <span className="font-bold">{Math.ceil(totalCount / limit)}</span>
          </span>

          <button
            onClick={goToNextPage}
            className="px-3 py-1 rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 transition duration-150"
            disabled={currentPage === Math.ceil(totalCount / limit)}
          >
            &gt;
          </button>
        </div>
      </div>

          <div class="mx-auto md:py-4">
        {/* <!-- Breadcrumb Start --> */}
        <div class="space-y-5 sm:space-y-6">
            <div class="rounded-2xl border border-gray-200 bg-white">
                <div class="px-5 py-4 sm:px-6 sm:py-5">
                    <h3 class="text-base font-medium text-gray-800">
                        
                    </h3>
                </div>
                <div class="p-5 border-t border-gray-100 sm:p-6">
                    {/* <!-- Table Start -->
                    <!-- Add your table content here -->
                    <!-- body Content -->
                    <!-- Body content End --> */}


                    <div
                    class="overflow-hidden rounded-xl border border-gray-200 bg-white"
                  >
                    <div className="overflow-x-auto">
                      <table className="min-w-full text-sm text-gray-700 text-center">
                        <thead className="bg-gray-100 text-xs uppercase text-gray-600">
                          <tr>
                            <th className="px-3 py-2">S.No</th>
                            <th className="px-3 py-2">Created On</th>
                            <th className="px-3 py-2">UTR</th>
                            <th className="px-3 py-2">Amount</th>
                            <th className="px-3 py-2">Open Balance</th>
                            <th className="px-3 py-2">Close Balance</th>
                            <th className="px-3 py-2">Status</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 text-center">
                          {fundloads.slice(1).length > 0 ? (
                            fundloads.slice(1).map((fund, index) => (
                              <tr key={fund.id} className="hover:bg-gray-50">
                                <td className="px-3 py-2">{index + 1}</td>
                                <td className="px-3 py-2">{fund.created_at}</td>
                                <td className="px-3 py-2">{fund.reference}</td>
                                <td
                              className={`px-3 py-2 font-semibold ${
                                fund.status === "3"
                                  ? "text-red-600"
                                  : "text-blue-600"
                              }`}
                            >
                              {fund.status === "3" ? "-" : "+"}
                              {fund.amount}
                            </td>
                                <td className="px-3 py-2">{fund.open_balance}</td>
                                <td className="px-3 py-2">{fund.close_balance}</td>
                                <td className="px-3 py-2">
                              <span
                                className={`text-xs font-medium px-2 py-1 rounded
                                  ${
                                    fund.status === "1"
                                      ? "bg-green-100 text-green-700"
                                      : fund.status === "2"
                                      ? "bg-blue-100 text-blue-700"
                                      : fund.status === "4"
                                      ? "bg-purple-100 text-purple-700"
                                      : "bg-red-100 text-red-700"
                                  }`}
                              >
                                {fund.status === "1"
                                  ? "Success"
                                  : fund.status === "2"
                                  ? "Internal Fund"
                                  : fund.status === "4"
                                  ? "Refund"
                                  : "Deduction"}
                              </span>
                            </td>

                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center py-4 text-gray-500">
                                No fund load history found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <hr className="mt-4" />
                  </div>
                  


                    {/* <!-- Table End --> */}
                </div>
            </div>
        </div>
    </div>


          
        </div>
      </main>
    </div>
  );
};

export default FundLoad;
